import { isLatinoChannel } from './latino-app';

const WEEE_PROD_GTM = 'GTM-KTQGLRG';
const WEEE_TEST_GTM = 'GTM-596KDHX';

const LATINO_PROD_GTM = 'GTM-T3WJBLJ3';
const LATINO_TEST_GTM = 'GTM-M795JTGD';

export const PROD_GTM = isLatinoChannel() ? LATINO_PROD_GTM : WEEE_PROD_GTM;
export const TEST_GTM = isLatinoChannel() ? LATINO_TEST_GTM : WEEE_TEST_GTM;
